<template>
    <transition name="fade">
        <div v-if="show" class="action-panel">
            <div class="action-panel__content">

                <button data-cy="panel-join-close" :class="['action-panel__close', {'click-down': closeClick}, {'click-up': closeClick === false}]"
                        @click="close"
                        @mousedown="closeDown"
                        @mouseup="closeUp"
                        @touchstart="closeDown"
                        @touchend="closeUp"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L13 13" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M13 1L1 13" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
                    </svg>
                </button>

                <div class="action-panel__head action-panel--invite">
                    <div class="action-panel__invite">
                        <div>
                            <img :src="$cdn('/img/ui/invite-friends.svg')" alt="Invite friends" width="24" height="25">
                            <p>Invite Friends &amp; Followers</p>
                        </div>
                        <div>
                            <img :src="community.logo" :alt="community.name + ' logo'" width="59" height="59">
                            <p>To <span class="u-bold">{{community.name}}</span></p>
                        </div>
                    </div>
                </div>
                <div class="action-panel__search--instructions">Search your followers by name or {{ $root.brand.name }} username below and click to select. Or type an email address and press enter.</div>
                <div class="action-panel__invite-recipients">
                    <div class="to">
                        To:
                    </div>
                    <div class="action-panel__invite-recipients--list">
                        <div class="recipient" v-for="(recipient, index) in recipients">
                            <p class="u-color-black" v-if="recipient.username">{{ recipient.username }}</p>
                            <p class="u-color-black" v-else-if="recipient.name">{{ recipient.name }}</p>
                            <p class="u-color-black" v-else>{{ recipient.email }}</p>
                            <img :src="$cdn('/img/ui/icon-remove-recipient.svg')" alt="Remove recipient" class="delete-recipient" @click="deleteRecipient(index)" width="9" height="8">
                        </div>
                        <div class="action-panel__invite-search">
                            <input v-model="search" ref="search" @keyup="getInput" class="c-textbox c-textbox--invite u-width-full u-m-b0" type="text" placeholder="Name, Username or Email">
                            <img :src="$cdn('/img/ui/icon-close-black.svg')" class="action-panel__clear-search" :class="{ active: isActive }" alt="Remove text" @click="clearInput" width="25" height="25">
                        </div>
                    </div>
                </div>
                <div ref="members" class="action-panel__members-wrap">
                    <div v-for="(member, index) in members" @click.prevent="selectUser($event, index)" v-bind:key="member.id">
                        <a href="#" class="action-panel__user" :data-id="member.id">
                            <img :src="$root.cloudinaryUrl + member.avatar" width="50" height="50" :alt="member.name">
                            <div class="action-panel__user--details">
                                <div class="action-panel__members action-panel__members--invite">
                                    <p>{{member.name}}<br>
                                        <span v-if="member.username" class="action-panel__members--tag">@{{member.username}}</span>
                                    </p>
                                    <div class="action-panel__member" v-show="member.member" :class="{ show : member.member, blink: member.blink }">
                                        <img :src="$cdn('/img/icons/icon-members.svg')" alt="Members Icon" width="24" height="16">
                                        <p>Member</p>
                                    </div>
                                    <div class="action-panel__accredited" v-show="member.accredited"
                                         :class="{ show : member.accredited }">
                                        <img :src="$cdn('/img/ui/icon-accredited.svg')" alt="Accredited Icon" width="8" height="8">
                                        <p>Accredited</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="action-panel__footer">
                    <a href="#" class="c-btn c-btn--invite c-btn--invite-panel" @click.prevent="sendInvitesModal">Send Invites</a>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            closeClick: null,
            isActive: false,
            members: [],
            search: '',
            recipients: [],
            show: false
        }
    },
    computed: {
        community() {
            let community = this.$root.community;
            community.logo = this.$simpleStore.transformImageWithCloudfront(66, 66, 'img/communities/' + this.$root.community.id + '/' + this.$root.community.image, this.$root);
            return community;
        }
    },
    created() {
        this.$root.$on('bus-show-invite-panel', this.open);
        this.$root.$on('bus-close-invite-panel', this.close);

        this.$root.$on('send-invites', this.sendInvites);
    },
    watch: {
        showInvitePanel(newValue, oldValue) {
            if (newValue === true) {
                this.$refs.search.focus();
                this.getUsers();
            }
        }
    },
    methods: {
        close() {
            this.show = false;
        },
        open() {
            this.show = true;
        },
        closeDown(event) {
            this.closeClick = true;
        },
        closeUp(event) {
            this.closeClick = false;
            setTimeout(() => {
                this.closeClick = null;
            }, 1000);
        },
        clearInput() {
            // remove X to clear search
            this.isActive = false;
            setTimeout(() => {
                this.search = '';
                this.members = [];
                this.$refs.search.focus();
            }, 200);
        },
        deleteRecipient(index) {
            let users = this.$refs.members.getElementsByClassName('action-panel__user');
            for (let user of users) {
                if (parseInt(user.dataset.id) === this.recipients[index].id) {
                    user.classList.remove('selected');
                    break;
                }
            }
            this.recipients.splice(index, 1);
            this.$refs.search.focus();
        },
        getInput(event) {
            const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (event.key === 'Enter' && reEmail.test(this.search.toLowerCase()) !== false) {
                this.recipients.push({ email: this.search });
                this.search = '';
                this.getUsers();
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            // get input after 800ms i.e. once user has stopped typing
            this.timer = setTimeout(() => {
                if (this.search.length > 0) {
                    this.isActive = true;
                    if (reEmail.test(this.search.toLowerCase()) === false) {
                        this.getUsers();
                    }
                } else {
                    this.isActive = false;
                }
            }, 800);
        },
        getUsers() {
            let contextData = {
                community_url: this.community.url,
                search: this.search
            };
            this.$http.post('/api/v1/user/' + this.$root.user.id + '/invitees', contextData).then(response => {
                this.members = response.data.results;
                this.$nextTick(() => {
                    this.recipients.forEach(recipient => {
                        if (this.members.some(user => user.id === recipient.id)) {
                            let users = this.$refs.members.getElementsByClassName('action-panel__user');
                            for (let user of users) {
                                if (parseInt(user.dataset.id) === recipient.id) {
                                    user.classList.add('selected');
                                    break;
                                }
                            }
                        }
                    });
                });
                for (let i = 1; i < response.data.total_pages; i++) {
                    let page = i + 1;
                    let contextDataPaged = {
                        community_url: this.community.url,
                        search: this.search,
                        page: page
                    };
                    this.$http.post('/api/v1/user/' + this.$root.user.id + '/invitees', contextDataPaged).then(response => {
                        this.members.push.apply(this.members, response.data.results);
                        // select user if already in recipients list
                        for (let recipient in this.recipients) {
                            console.log('recipient', recipient);
                            console.log('member some:', this.members.some(user => user.id === recipient.id));
                        }
                        let users = this.$refs.members.getElementsByClassName('action-panel__user');
                        for (let user of users) {
                            if (parseInt(user.dataset.id) === this.recipients[index].id) {
                                user.classList.remove('selected');
                                break;
                            }
                        }

                    }, response => {
                        console.log('Errored:');
                        console.log(response);
                    });
                }
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        selectUser(event, index) {
            let selectedUser = this.members[index];
            let recipient = { id: selectedUser.id, name: selectedUser.name, username: selectedUser.username };
            if (selectedUser.member == null && this.recipients.some(item => item.id === selectedUser.id) === false) {
                this.recipients.push(recipient);
                console.log(this.recipients);
                this.$refs.search.focus();
                event.target.closest('.action-panel__user').classList.add('selected');
            } else {
                selectedUser.blink = true;
                this.$set(this.members, index, selectedUser);
                setTimeout(() => {
                    selectedUser.blink = false;
                    this.$set(this.members, index, selectedUser);
                }, 5000);
            }
        },
        sendInvitesModal() {
            let message = 'We will now send community invites to the following people:<br>';
            this.recipients.forEach(recipient => {
                message += (recipient.name != null ? recipient.name : recipient.email) + '<br>';
            });
            let modalData = {
                cta: false,
                title: 'Confirm Invites',
                message: message,
                emit: 'send-invites',
                buttonText: 'Send Invites'
            };
            this.closeInvitePanel();
            this.$root.$emit('bus-show-community-modal', modalData);
        },
        sendInvites() {
            this.$http.post('/api/v1/sendinvites', { communityId: this.community.id, recipients: this.recipients}).then(response => {
                this.recipients = [];
                let modalData = {
                    cta: false,
                    title: 'Invites Sent',
                    message: 'Your invites have been successfully sent',
                    emit: 'bus-close-invite-panel',
                    buttonText: null
                };
                this.$root.$emit('bus-show-community-modal', modalData);
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        }
    }
}
</script>
